import { render, staticRenderFns } from "./amsVgmReminderForm.vue?vue&type=template&id=d873542a&scoped=true&"
import script from "./amsVgmReminderForm.vue?vue&type=script&lang=js&"
export * from "./amsVgmReminderForm.vue?vue&type=script&lang=js&"
import style0 from "./amsVgmReminderForm.vue?vue&type=style&index=0&id=d873542a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d873542a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d873542a')) {
      api.createRecord('d873542a', component.options)
    } else {
      api.reload('d873542a', component.options)
    }
    module.hot.accept("./amsVgmReminderForm.vue?vue&type=template&id=d873542a&scoped=true&", function () {
      api.rerender('d873542a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/warnRuleConfiguration/amsVgmReminderForm.vue"
export default component.exports